module.exports = __webpack_public_path__ + "media/images/countryrect/af-8bb89351a325940f929f2d30ce9bd6fe.svg";